import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import { OtaUpdate } from '../../../types/otaUpdate';
import { statusBadgeClass } from './otaData';

/** The scheduled updates and their progress. Empty until the API exposes them. */
export const PendingUpdatesTab: React.FC<{ updates: OtaUpdate[] }> = ({ updates }) => {
  const { formatDateTime, t } = useI18n();

  if (updates.length === 0) {
    return (
      <div className="pending-updates-list">
        <div className="empty-state">
          <div className="empty-icon">✓</div>
          <h3>{t('otaUpdates.noPendingUpdates')}</h3>
          <p>{t('otaUpdates.noPendingHint')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="pending-updates-list">
      <table className="ota-table">
        <thead>
          <tr>
            <th>{t('otaUpdates.device')}</th>
            <th>{t('otaUpdates.targetVersion')}</th>
            <th>{t('otaUpdates.status')}</th>
            <th>{t('otaUpdates.progress')}</th>
            <th>{t('otaUpdates.scheduled')}</th>
            <th>{t('otaUpdates.actions')}</th>
          </tr>
        </thead>
        <tbody>
          {updates.map((update) => (
            <tr key={update.id}>
              <td>
                <div className="device-info">
                  <strong>{update.device_name}</strong>
                  <span className="device-id">{update.device_id}</span>
                </div>
              </td>
              <td className="version">v{update.firmware_version}</td>
              <td><span className={statusBadgeClass(update.status)}>{update.status.replace('_', ' ')}</span></td>
              <td>
                {update.status === 'in_progress' && (
                  <div className="progress-bar">
                    <div className="progress-fill" style={{ width: `${update.progress}%` }} />
                    <span className="progress-text">{update.progress}%</span>
                  </div>
                )}
                {update.status === 'pending' && <span className="muted">-</span>}
              </td>
              <td className="muted">{update.scheduled_at && formatDateTime(update.scheduled_at)}</td>
              <td>{update.status === 'pending' && <button type="button" className="btn btn-sm btn-secondary">{t('common.cancel')}</button>}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
